import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Popover } from 'element-ui';
import { POPPER_OPEN_DELAY } from '@/constants';
import { useFamilySearchPatentInfo } from '@/composables/use-family-search-patent-info';
import { useI18n } from '@/composables/use-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilySearchHeaderTitle',
  setup(__props) {

const ElPopover = Popover;
const { patentInfo, isLoading } = useFamilySearchPatentInfo();
const { t } = useI18n();

const title = computed(() => `${patentInfo.value.translation ? `[${t('translateTitle')}]` : ''} ${patentInfo.value.title || ''}`);

return { __sfc: true,ElPopover, patentInfo, isLoading, t, title, POPPER_OPEN_DELAY }
}

})